import {ReactReduxContext, useDispatch} from "react-redux";
import React, {useContext} from "react";
import {PanelHeader} from "../panelHeader";

/**
 * Creates a PanelList component.
 * @param {Object} contents - The contents of the panel list.
 * @param {string} contents.title - The title of the panel list.
 * @param {Array<Object>} contents.data - The data for the panel list items.
 * @param {string} id - The unique identifier for the panel list.
 * @param {{string}}ariaLabel - label for aria-label for this panel list
 * @returns {Element} - The rendered panel list component.
 */
export function PanelList({contents, id, ariaLabel}) {
    const dispatch = useDispatch();
    const context = useContext(ReactReduxContext);
    const step4 = context.store.getState().app.stepData.step4;

    const isVisible = step4.panelList[id].isVisible;

    if (!contents || !contents.title || !Array.isArray(contents.data)) {
        return <></>
    }

    const totalValue = contents.data
        .reduce((accumulatedValue, currentItem) => {
            return accumulatedValue + (isNaN(currentItem.value)
                ? 0
                : currentItem.value)
        }, 0);

    return (
        <li className="panel-list-ul" key={id}>
            <details open className="panel-list-ul">
                <summary className="step4-summary"><PanelHeader className="panel-header" text={contents.title}
                                                                value={totalValue}/></summary>
                <ul aria-label="{ariaLabel}">
                    {contents.data.map((item, index) => {
                        if (item.title && !isNaN(item.value)) {
                            return <li key={id + '_' + index}><PanelHeader key={'panel_' + id + '_' + index} text={item.title} value={item.value}
                                                    className={`panel-list-item-${index}`}/></li>
                        }
                        return null;
                    })}
                </ul>
            </details>
        </li>
    );
}